import { CoreModule } from '@core/core.module';
import { TranslationsModule } from '@core/translate';
import { Module } from '@rxdi/core';
import { RouterModule } from '@rxdi/router';
import { SharedModule } from '@shared/shared.module';

import { AppComponent } from './app.component';
import BG from './core/i18n/bg.json';
import EN from './core/i18n/en.json';
import { SiteFooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { NavbarComponent } from './navbar/navbar.component';

@Module({
  components: [NavbarComponent, HomeComponent, SiteFooterComponent],
  imports: [
    TranslationsModule.forRoot({
      translations: { EN, BG },
    }),
    SharedModule,
    CoreModule,
    RouterModule.forRoot(
      [
        {
          path: '/',
          component: HomeComponent,
        },
        {
          path: '/products',
          children: () => import('./products/products.module'),
        },
        {
          path: '/about',
          children: () => import('./about/about.module'),
        },
        {
          path: '/admin',
          children: () => import('./admin/admin.module'),
        },
        {
          path: '/blog',
          children: () => import('./blog/blog.module'),
        },
        {
          path: '/login',
          children: () => import('./login/login.module'),
        },
        {
          path: '(.*)',
          component: 'not-found-component',
          action: () => import('./not-found/not-found.component'),
        },
      ],
      { log: true }
    ),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
